export enum ForecastMethods {
  'Haircut %',
  'Growth %'
  // 'Vintage Runoff'
}

export interface IForecastSettings {
  ForecastMethod: ForecastMethods;
  ForecastGrowth: number;
  ForecastUpDamper: number;
  ForecastDownDamper: number;
}
